export default theme => ({
  backdrop: {
    backgroundColor: "rgba(0,0,0,0.6)",
  },

  paper: {
    width: 320,
    maxWidth: "calc(100vw - 40px)",
    margin: 20,
    padding: 24,
    boxSizing: "border-box",
    borderRadius: 24,
    border: "1px solid #dbdbdb",
    backgroundColor: "#fcfcfc",
    boxShadow: "0px 4px 16px rgba(0,0,0,0.15)",
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    padding: 0,
    "&:first-child": {
      paddingTop: 0,
    },
  },

  textBlock: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },

  title: {
    margin: 0,
    fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: 1.35,
    color: "#333232",
  },

  body: {
    margin: 0,
    fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1.25,
    color: "#6b6b6b",
  },

  actions: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    width: "100%",
  },

  primaryBtn: {
    "&&": {
      width: "100%",
      minHeight: 48,
      height: 48,
      margin: 0,
      borderRadius: 10,
      padding: "12px 16px",
      fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1.5,
      textTransform: "none",
      boxShadow: "none",
    },
  },

  secondaryBtn: {
    "&&": {
      width: "100%",
      minHeight: 48,
      height: 48,
      margin: 0,
      borderRadius: 10,
      padding: "12px 16px",
      border: "1px solid #e3e3e3",
      backgroundColor: "#f0f0f0",
      color: "#282727",
      fontFamily: '"Instrument Sans", Helvetica, Arial, sans-serif',
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 1.5,
      textTransform: "none",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#e8e8e8",
        boxShadow: "none",
      },
    },
  },
});
